import React from 'react';
import parse from 'html-react-parser';
import { shapes } from './problemGenerators';

const Problem = ({problemNumber, setProblemNumber, problemsCorrect, setProblemsCorrect}) => {

    // Initialize settings
    const fractionCorrect = problemsCorrect/problemNumber;
    const difficulty = problemNumber > 10 ? fractionCorrect > 0.8 ? 2 : 1 : 1;  // 2 levels of difficulty

    // Initialize displayed problem data
    let problemData = {
        text: "",
        correctAnswer: "",
        wrongAnswers: {
            wrong1: "",
            wrong2: "",
            wrong3: ""
        }
    };

    // Array of functions to randomly call to create the problems. Each function = problem type; equal chance of choosing
    const problemGenerator = [

        // direct calculation
        shapes.square.findPerimeter.numbers,
        shapes.square.findArea.numbers,
        shapes.rectangle.findPerimeter.numbers,
        shapes.rectangle.findArea.numbers, 
        shapes.triangle.findPerimeter.numbers, 
        shapes.triangle.findArea.numbers, 
        shapes.circle.findCircumference.numbers,
        shapes.circle.findArea.numbers,
        shapes.rectangularPrism.findSurfaceArea.numbers, 
        shapes.rectangularPrism.findVolume.numbers,

        // find missing dimension
        shapes.square.findMissingDimension.givenPerimeter,
        shapes.square.findMissingDimension.givenArea,
        shapes.rectangle.findMissingDimension.givenPerimeter,
        shapes.rectangle.findMissingDimension.givenArea,
        shapes.triangle.findMissingDimension.givenPerimeter, 
        shapes.triangle.findMissingDimension.givenArea,
        shapes.triangle.findMissingDimension.ofRightTriangle,
        shapes.circle.findMissingDimension.givenCircumference,
        shapes.circle.findMissingDimension.givenArea,
        shapes.rectangularPrism.findMissingDimension.givenSurfaceArea,
        shapes.rectangularPrism.findMissingDimension.givenVolume,        

        // multiple formula use, basic shapes
        shapes.square.findPerimeter.givenArea,
        shapes.square.findArea.givenPerimeter,
        shapes.rectangle.findPerimeter.givenArea,
        shapes.rectangle.findArea.givenPerimeter,
        shapes.triangle.findPerimeter.ofRightTriangle,
        shapes.triangle.findArea.ofRightTriangle,
        shapes.rectangularPrism.findSurfaceArea.givenVolume,
        shapes.rectangularPrism.findVolume.givenSurfaceArea

        // find missing dimension: literal equations
        // money, proportions
        // speed, distance, time
        // compound areas
        // area probability, percentages
        // unit conversions
        // mean, median, mode 
        // similar triangles?
    ]; 

    // Populate the problem content to be displayed
    const maxNumberProblemTypes = problemGenerator.length; // Count the no. of functions available
    const problemIndex = Math.floor(maxNumberProblemTypes*Math.random()); // Each type
    [problemData.text, problemData.correctAnswer, problemData.wrongAnswers.wrong1, problemData.wrongAnswers.wrong2, problemData.wrongAnswers.wrong3] = problemGenerator[problemIndex](difficulty); // generate problem
    // Randomize answer positions
    let displayedAnswers = [problemData.correctAnswer, problemData.wrongAnswers.wrong1, problemData.wrongAnswers.wrong2, problemData.wrongAnswers.wrong3];
    displayedAnswers = shuffle(displayedAnswers);

    // More support functions ===============================================================

    // Randomize array element order; see: https://stackoverflow.com/questions/2450954/how-to-randomize-shuffle-a-javascript-array
    function shuffle(array) {
        let currentIndex = array.length,  randomIndex;
        // While there remain elements to shuffle.
        while (currentIndex !== 0) {
          // Pick a remaining element.
          randomIndex = Math.floor(Math.random() * currentIndex);
          currentIndex--;
          // And swap it with the current element.
          [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
        }
        return array;
    }

    const skipToNextProblem = () => {
        let checkedElem = document.querySelector('input[name="problem"]:checked');
        enableButtons();
        document.getElementById("button-next").classList.remove("pulse"); 
        document.getElementById("incorrect").classList.remove("visible","expandOpen");
        if(checkedElem!=null){
            checkedElem.checked = false;
        }
        setProblemNumber(problemNumber + 1);
        changeProblemStyle();  
    };

    const checkAnswer = () => {
        // console.log("Checking answer..."); // debug
        let selectedAnswer;
        const messageTime = 2000;
        let checkedElem = document.querySelector('input[name="problem"]:checked');
        if(checkedElem!=null){
            selectedAnswer = checkedElem.value;
            if(String(selectedAnswer)===String(problemData.correctAnswer)){
                console.log(`Problem #${problemNumber}: Correct!`);
                // display message, disable submit answer button, emphasize "next problem" button, reset answers on delay
                document.getElementById("correct").classList.add("visible","bounce");
                disableButtons();
                disableRadio();
                setTimeout(() => {
                    enableButtons();
                    enableRadio();
                    checkedElem.checked = false; // reset radio buttons
                    setProblemsCorrect(problemsCorrect + 1);
                    setProblemNumber(problemNumber + 1);
                    document.getElementById("correct").classList.remove("visible","bounce");
                    document.getElementById("button-next").classList.remove("pulse"); 
                    changeProblemStyle();     
                }, messageTime);
            } else {
                console.log(`Problem #${problemNumber}: Incorrect...`);
                // display message, disable submit answer button, emphasize "next problem" button, reset answers on delay
                document.getElementById("incorrect").classList.add("visible","expandOpen");
                disableButtons();
                disableRadio();
                setTimeout(() => {
                    checkedElem.checked = false;
                    document.getElementById("incorrect").classList.remove("visible","expandOpen");
                    enableButtons();
                    enableRadio();
                    document.getElementById("button-next").classList.add("pulse"); 
                }, messageTime);
            }
        } else {
            console.log("No answer selected!"); // debug
        }       
    };

    const changeProblemStyle = () => {
        const hue = Math.floor(360*Math.random());
        const lightness = Math.floor(40*Math.random()) + 10;
        const randColor = `hsl(${hue}, 100%, ${lightness}%)`;
        document.getElementById("title").style.color = randColor;
    };

    const disableButtons = () => {
        document.getElementById("button-submit").disabled = true; 
        document.getElementById("button-next").disabled = true; 
    };

    const enableButtons = () => {
        document.getElementById("button-submit").disabled = false; 
        document.getElementById("button-next").disabled = false; 
        // console.log("Buttons enabled."); // debug
    };

    const disableRadio = () => {
        document.getElementById("answer-a").disabled = true;
        document.getElementById("answer-b").disabled = true;
        document.getElementById("answer-c").disabled = true;
        document.getElementById("answer-d").disabled = true;
    };

    const enableRadio = () => {
        document.getElementById("answer-a").disabled = false;
        document.getElementById("answer-b").disabled = false;
        document.getElementById("answer-c").disabled = false;
        document.getElementById("answer-d").disabled = false;
    };

    // render =============================================================================================
    return(
        <div className="question columns">
            <div className="column">        
                <div className="columns">
                    <div className="question-text column">
                        <p className="content">
                            { parse(problemData.text) }
                        </p>
                    </div>
                    {/* <div className="problem-image column">
                        <img src="http://placekitten.com/400/300" title="TBD" alt="Describe something"/>
                        <div id="question-image-canvas"></div>
                    </div> */}
                </div>
                <div className="problem-answers">
                    <form className="columns" id="answer-options">
                        <div className="column">  
                            <label>
                                <input type="radio" id="answer-a" name="problem" value={displayedAnswers[0]} />
                                <span className="answer-label">A. </span> 
                                <span>{parse(displayedAnswers[0])}</span>
                            </label>                 
                        </div>
                        <div className="column">  
                            <label>
                                <input type="radio" id="answer-b" name="problem" value={displayedAnswers[1]} />
                                <span className="answer-label">B. </span> 
                                <span>{parse(displayedAnswers[1])}</span>
                            </label>                 
                        </div>
                        <div className="column">  
                            <label>
                                <input type="radio" id="answer-c" name="problem" value={displayedAnswers[2]} />
                                <span className="answer-label">C. </span> 
                                <span>{parse(displayedAnswers[2])}</span>
                            </label>                
                        </div>
                        <div className="column">  
                            <label>
                                <input type="radio" id="answer-d" name="problem" value={displayedAnswers[3]} />
                                <span className="answer-label">D. </span> 
                                <span>{parse(displayedAnswers[3])}</span>
                            </label>                   
                        </div>
                    </form>
                </div>

                <div className="buttons">
                    <button className="button is-primary" id="button-submit" onClick={checkAnswer}>
                        Submit Answer!
                    </button>
                    <button className="button is-warning" id="button-next" onClick={skipToNextProblem}>
                        Next Problem &rarr;
                    </button>
                </div>

            </div>
        </div>
    );

};

export default Problem;